import React from "react";
import { Grid, Skeleton, useMediaQuery } from "@mui/material";

const ProductDetailsSkeleton = () => {
  const max_width600 = useMediaQuery("(max-width:600px)");
  return (
    <div className="order-product-details">
      <Grid container>
        <Grid item xs={12} className="title">
          Details
        </Grid>

        <Grid container item className="single-product">
          <Grid item xs={9} sm={8}>
            <div className="product-basic-details">
              <div className="product-img">
                <Skeleton height={100} width={100} animation="wave" />
              </div>
              <div
                className="product-name-size-color"
                style={{ width: "100%" }}
              >
                <Skeleton
                  className="product-name"
                  width={max_width600 ? "80%" : "70%"}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  className="product-size"
                  width={max_width600 ? "50%" : "30%"}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  className="product-color"
                  width={max_width600 ? "50%" : "30%"}
                  height={20}
                  animation="wave"
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={1.5} sm={2}>
            <Skeleton
              className="product-qty"
              width={"50%"}
              height={20}
              animation="wave"
            />
          </Grid>
          <Grid item xs={1.5} sm={2}>
            <Skeleton
              className="product-price"
              width={"70%"}
              height={20}
              animation="wave"
            />
          </Grid>
        </Grid>

        <Grid item container>
          <Grid item xs={false} sm={6} md={7} lg={8} />
          <Grid item xs={12} sm={6} md={5} lg={4}>
            <div className="pricing">
              <div className="subtotal item">
                <div className="label">Subtotal</div>
                <Skeleton
                  className="price"
                  width={"15%"}
                  height={20}
                  animation="wave"
                />
              </div>
              <div className="discount item">
                <div className="label">Discount</div>
                <Skeleton
                  className="price"
                  width={"15%"}
                  height={20}
                  animation="wave"
                />
              </div>
              <div className="coupon-discount item">
                <div className="label">
                  <p>Coupon Discount</p>
                  <p className="coupon-name">- FLAT10</p>
                </div>
                <Skeleton
                  className="price"
                  width={"15%"}
                  height={20}
                  animation="wave"
                />
              </div>
              <div className="shipping item">
                <div className="label">Shipping</div>
                <div className="price">Free</div>
              </div>
              <div className="total item">
                <div className="label">Total</div>
                <Skeleton
                  className="price"
                  width={"15%"}
                  height={30}
                  animation="wave"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductDetailsSkeleton;
